const ElementGroups = {
	block: "block",
	inline: "inline",
	listItem: "listItem",
	listItemContent: "listItemContent",
	tab: "tab",
};

export default ElementGroups;
